module.exports = (__parcel__import__("fhenR")).then(() => parcelRequire('4MKVl'));